export const search = () => window.location?.search;
export const href = () => window.location?.href;
export const origin = () => window.location?.origin;
export const host = () => window.location?.host;
export const hash = () => window.location?.hash;
export const protocol = () => window.location?.protocol;
export const setHref = (url: string, windowArg = window) => (windowArg.location.href = url);
export const replace = (replacement: string) => window.location.replace(replacement);
export const hostname = () => window.location?.hostname;
export const openNewWindow = (url: string) => window.open(url, '_blank');
export const reload = () => window.location?.reload();
export const pathname = () => window.location?.pathname;
export const getNewWindow = (): Window => window.open() || window;
export const setFetch = (data: typeof window.fetch) => (window.fetch = data);
